import { SidebarMenuItem } from "@/src/sb/business-layer/types"

const NavigationMenuMock = (): Array<SidebarMenuItem> => {
  return [
    // SideBar Top Menu
    {
      id: 100001,
      icon:
        '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M14 1.75C7.23451 1.75 1.75 7.23451 1.75 14C1.75 20.7655 7.23451 26.25 14 26.25C20.7655 26.25 26.25 20.7655 26.25 14C26.2423 7.23771 20.7623 1.75772 14 1.75ZM3.5 14C3.50184 11.0188 4.77501 8.17999 7 6.19588V7.875C7 8.8415 7.7835 9.625 8.75 9.625H11.7092C12.3725 9.62531 12.979 9.25059 13.2755 8.65725L13.6649 7.875H15.75V11.375H11.5806C11.3094 11.3749 11.042 11.4378 10.7993 11.5588L7.96688 12.9763C7.37472 13.2726 7.00052 13.8777 7 14.5399V17.7818C6.99995 18.4973 7.43553 19.1408 8.09987 19.4066L11.4677 20.7541L12.061 24.3119C7.10206 23.3751 3.5085 19.0466 3.5 14ZM13.8652 24.493L13.0322 19.495L8.75 17.7826V14.5408L11.5815 13.125H17.5V6.125H12.5842L11.7092 7.875H8.75V4.92013C11.4472 3.35005 14.7045 3.06595 17.6327 4.14535C20.561 5.22476 22.8546 7.55498 23.8875 10.5H19.25V14L20.0567 17.3364L18.375 19.8608V23.5331C17.004 24.1689 15.5112 24.4988 14 24.5C13.9545 24.5 13.9107 24.4939 13.8652 24.493ZM20.125 22.5111V20.3901L21.5127 18.3076C21.7863 17.8972 21.8743 17.3906 21.7551 16.912L21 13.8924V12.25H24.3425C25.0408 16.1983 23.398 20.1951 20.125 22.5111Z" fill="currentColor"/>' +
        "</svg>",
      destination: "/",
      label: "Country Risk",
      parent_id: null,
      category_name: null
    },
    {
      id: 100002,
      icon:
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M2.91875 17.5L6.9125 10L11.475 14.0562C11.7645 14.3135 12.157 14.422 12.5375 14.35C12.9216 14.2781 13.25 14.0306 13.425 13.6812L16.875 6.8125L15.7375 6.25L12.3063 13.125L7.74375 9.06875C7.46159 8.80634 7.07417 8.68874 6.69375 8.75C6.31818 8.81231 5.99147 9.04239 5.80625 9.375L2.5 15.625V1.25H1.25V17.5C1.25 18.1904 1.80964 18.75 2.5 18.75H18.75V17.5H2.91875Z" fill="currentColor"/>\n' +
        "</svg>",
      destination: "/",
      label: "Data",
      parent_id: null,
      category_name: null
    },
    {
      id: 100003,
      icon:
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 15.8334H8.54167V17.2917H1.25V15.8334ZM1.25 11.4584H8.54167V12.9167H1.25V11.4584ZM17.2917 8.54142H2.70833C1.90292 8.54142 1.25 7.8885 1.25 7.08309V2.70809C1.25 1.90267 1.90292 1.24976 2.70833 1.24976H17.2917C18.0971 1.24976 18.75 1.90267 18.75 2.70809V7.08309C18.75 7.8885 18.0971 8.54142 17.2917 8.54142ZM2.70776 2.70837V7.08337H17.2911V2.70837H2.70776ZM17.2911 18.75H12.9161C12.1107 18.75 11.4578 18.0971 11.4578 17.2917V12.9167C11.4578 12.1113 12.1107 11.4584 12.9161 11.4584H17.2911C18.0965 11.4584 18.7494 12.1113 18.7494 12.9167V17.2917C18.7494 18.0971 18.0965 18.75 17.2911 18.75ZM12.9172 12.9161V17.2911H17.2922V12.9161H12.9172Z" fill="currentColor"/>\n' +
        "</svg>",
      destination: "/",
      label: "Reports",
      parent_id: null,
      category_name: null
    },

    // SideBar Submenu - 1st depth
    {
      id: 1000010,
      label: "Financial Services",
      destination: "#",
      parent_id: 100002,
      category_name: null
    },
    {
      id: 1000020,
      label: "Macroeconomy",
      destination: "#",
      parent_id: 100002,
      category_name: null
    },
    {
      id: 1000030,
      label: "Energy",
      destination: "#",
      parent_id: 100002,
      category_name: null
    },
    {
      id: 1000033,
      label: "Consumer",
      destination: "#",
      parent_id: 100002,
      category_name: null
    },
    {
      id: 1000036,
      label: "Political Economy",
      destination: "#",
      parent_id: 100002,
      category_name: null
    },
    {
      id: 10000090,
      label: "Nigeria Consumer Lending Market Size",
      destination:
        "/data/financial-services/nigeria-consumer-lending-market-size",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000100,
      label: "Borrowing Behaviour in Africa",
      destination: "/data/financial-services/borrowing-behaviour-in-africa/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000110,
      label: "Saving Behaviour in Africa",
      destination: "/data/financial-services/saving-behaviour-in-africa/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000120,
      label: "Digital payments in Africa",
      destination: "/data/financial-services/digital-payments-in-africa/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000130,
      label: "Formal Account Usage in Africa",
      destination:
        "/data/financial-services/formal-account-usage-in-africa-by-gender/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000133,
      label: "Saving Behaviour by Gender",
      destination: "/data/financial-services/saving-behaviour-by-gender/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000136,
      label: "Borrowing Behaviour by Gender",
      destination: "/data/financial-services/borrowing-behaviour-by-gender/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000139,
      label: "Domestic remittances trends",
      destination: "/data/financial-services/domestic-remittances-trends/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000142,
      label: "Domestic remittances trends by gender",
      destination:
        "/data/financial-services/domestic-remittances-trends-by-gender/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000145,
      label: "Distribution of wages by gender",
      destination: "/data/financial-services/distribution-of-wages-by-gender/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 10000148,
      label: "Distribution of wages by payment channel",
      destination:
        "/data/financial-services/distribution-of-wages-by-payment-channel/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001100,
      label: "Interest on deposits",
      destination: "/data/financial-services/interest-on-deposits/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001110,
      label: "Lending rate",
      destination: "/data/financial-services/lending-interest-rate/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001120,
      label: "Interest rate spread",
      destination: "/data/financial-services/interest-rate-spread/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001540,
      label: "Domestic credit to private sector by banks as a % of GDP",
      destination:
        "/data/financial-services/domestic-credit-to-private-sector-by-banks-as-a-of-gdp/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001560,
      label: "Banks NPL to gross loans (%)",
      destination: "/data/financial-services/banks-npl-to-gross-loans/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001580,
      label: "Borrowers from commercial banks per 1000 adults",
      destination:
        "/data/financial-services/borrowers-from-commercial-banks-per-1000-adults/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001600,
      label: "Domestic Credit to Private Sector (% of GDP)",
      destination:
        "/data/financial-services/domestic-credit-to-private-sector-of-gdp/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001620,
      label: "Monetary Sector credit to private sector (% GDP)",
      destination:
        "/data/financial-services/monetary-sector-credit-to-private-sector-gdp/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001760,
      label: "Sectoral Allocation of Credit (Ghana)",
      destination:
        "/dataset/financial-services/sectoral-allocation-of-credit-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001780,
      label: "Central Bank Assets (Ghana)",
      destination: "/dataset/financial-services/central-bank-assets-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001800,
      label: "Commercial Banks Assets (Ghana)",
      destination: "/dataset/financial-services/commercial-banks-assets-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 1000060,
      label: "Exchange rates",
      destination: "#",
      parent_id: 1000020,
      category_name: null
    },
    {
      id: 1000070,
      label: "Inflation",
      destination: "#",
      parent_id: 1000020,
      category_name: null
    },
    {
      id: 1000080,
      label: "Economic growth",
      destination: "#",
      parent_id: 1000020,
      category_name: null
    },
    {
      id: 100001959,
      label: "Real GDP, Nigeria, Annual",
      destination: "/datasets/real-gdp-nigeria-annual/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 100001960,
      label: "Real GDP, Nigeria, Quarterly",
      destination: "/datasets/real-gdp-nigeria-quarterly/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 100001961,
      label: "Nominal GDP, Nigeria, Annual",
      destination: "/datasets/nominal-gdp-nigeria-annual/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 100001962,
      label: "Nominal GDP, Nigeria, Quarterly",
      destination: "/datasets/nominal-gdp-nigeria-quarterly/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 100001963,
      label: "Foreign Exchange Reserve",
      destination: "/datasets/foreign-exchange-reserve/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 1000082,
      label: "Trade",
      destination: "#",
      parent_id: 1000020,
      category_name: null
    },
    {
      id: 1000084,
      label: "Fiscal",
      destination: "#",
      parent_id: 1000020,
      category_name: null
    },
    {
      id: 1000085,
      label: "Employment",
      destination: "#",
      parent_id: 1000020,
      category_name: null
    },
    {
      id: 1000087,
      label: "Wages",
      destination: "#",
      parent_id: 1000020,
      category_name: null
    },
    {
      id: 1000090,
      label: "Monetary policy",
      destination: "#",
      parent_id: 1000020,
      category_name: null
    },
    {
      id: 1000094,
      label: "Industry and Manufacturing",
      destination: "#",
      parent_id: 1000020,
      category_name: null
    },

    {
      id: 10000140,
      label: "Inflation Forecast",
      destination: "/data/inflation/forecast/",
      parent_id: 1000070,
      category_name: null
    },
    {
      id: 10000150,
      label: "Lending Rate",
      destination: "/data/inflation/lending-rate/",
      parent_id: 1000090,
      category_name: null
    },
    {
      id: 10000160,
      label: "Monetary Policy Rate",
      destination: "/data/inflation/monetary-policy-rate/",
      parent_id: 1000090,
      category_name: null
    },
    {
      id: 10000170,
      label: "Money Supply Growth Rate",
      destination: "/data/inflation/money-supply-growth-rate/",
      parent_id: 1000090,
      category_name: null
    },
    {
      id: 10000173,
      label: "Broad Money Supply (annual average)",
      destination: "/data/inflation/broad-money-supply-annual-average/",
      parent_id: 1000090,
      category_name: null
    },
    {
      id: 10000175,
      label: "Broad Money Supply Growth (annual average %)",
      destination: "/data/inflation/broad-money-supply-growth-annual-average/",
      parent_id: 1000090,
      category_name: null
    },
    {
      id: 10000178,
      label: "Monetary Policy Rate (monthly)",
      destination: "/dataset/macroeconomy/monetary-policy-rate-monthly/",
      parent_id: 1000090,
      category_name: null
    },
    {
      id: 100001900,
      label: "Bank Lending Rate (Prime)",
      destination: "/dataset/macroeconomy/bank-lending-rate-prime/",
      parent_id: 1000090,
      category_name: null
    },
    {
      id: 100001920,
      label: "Broad Money Supply (M2, monthly)",
      destination: "/dataset/macroeconomy/broad-money-supply-m2-monthly/",
      parent_id: 1000090,
      category_name: null
    },

    {
      id: 100001967,
      label: "10-year Eurobond Yield, Kenya",
      destination: "/datasets/10-year-eurobond-yield-kenya/",
      parent_id: 1000090,
      category_name: null
    },

    {
      id: 100001640,
      label: "Industry, value added (% of GDP)",
      destination: "/data/macroeconomy/industry-value-added-of-gdp/",
      parent_id: 1000094,
      category_name: null
    },
    {
      id: 100001660,
      label: "Industry, value added (annual % growth)",
      destination: "/data/macroeconomy/industry-value-added-annual-growth/",
      parent_id: 1000094,
      category_name: null
    },
    {
      id: 100001680,
      label: "Manufacturing, value added (current US$)",
      destination: "/data/macroeconomy/manufacturing-value-added-current-us/",
      parent_id: 1000094,
      category_name: null
    },
    {
      id: 100001700,
      label: "Manufacturing, Value added (% of GDP)",
      destination: "/data/macroeconomy/manufacturing-value-added-of-gdp/",
      parent_id: 1000094,
      category_name: null
    },

    {
      id: 10000180,
      label: "Consumer Price Index (CPI)",
      destination: "/data/inflation/consumer-price-index-cpi/",
      parent_id: 1000070,
      category_name: null
    },
    {
      id: 10000190,
      label: "Core Inflation",
      destination: "/data/inflation/core-inflation/",
      parent_id: 1000070,
      category_name: null
    },
    {
      id: 10000200,
      label: "Global Food Price Index",
      destination: "/data/inflation/global-food-price-index/",
      parent_id: 1000070,
      category_name: null
    },
    {
      id: 10000201,
      label: "Inflation, consumer prices (annual average %)",
      destination: "/data/inflation/inflation-consumer-prices-annual-average/",
      parent_id: 1000070,
      category_name: null
    },
    {
      id: 10000202,
      label: "Consumer Price Index (annual average)",
      destination: "/data/inflation/consumer-price-index-annual-average/",
      parent_id: 1000070,
      category_name: null
    },
    {
      id: 10000205,
      label: "Inflation, consumer prices (monthly)",
      destination: "/dataset/macroeconomy/inflation-consumer-prices-monthly/",
      parent_id: 1000070,
      category_name: null
    },
    {
      id: 10000950,
      label: "Vulnerable Employment, total (% of total employment)",
      destination: "/data/inflation/vulnerable-employment-total/",
      parent_id: 1000085,
      category_name: null
    },
    {
      id: 100001965,
      label: "Unemployment, Quarterly",
      destination: "/datasets/unemployment/",
      parent_id: 1000085,
      category_name: null
    },
    {
      id: 10000960,
      label: "Vulnerable Employment, female (% of female employment)",
      destination: "/data/inflation/vulnerable-employment-female/",
      parent_id: 1000085,
      category_name: null
    },
    {
      id: 10000970,
      label: "Vulnerable Employment, male (% of male employment)",
      destination: "/data/inflation/vulnerable-employment-male/",
      parent_id: 1000085,
      category_name: null
    },
    {
      id: 100001480,
      label: "Unemployment, total (% of total labor force)",
      destination:
        "/data/macroeconomy/unemployment-total-of-total-labor-force/",
      parent_id: 1000085,
      category_name: null
    },
    {
      id: 100001500,
      label: "Unemployment, female (% of female labor force)",
      destination:
        "/data/macroeconomy/unemployment-female-of-female-labor-force/",
      parent_id: 1000085,
      category_name: null
    },
    {
      id: 100001520,
      label: "Unemployment, male (% of male labor force)",
      destination: "/data/macroeconomy/unemployment-male-of-male-labor-force/",
      parent_id: 1000085,
      category_name: null
    },
    {
      id: 10000980,
      label: "Wage and salaried workers, total (% of total employment)",
      destination: "/data/inflation/wage-and-salaried-workers-total/",
      parent_id: 1000087,
      category_name: null
    },
    {
      id: 10000990,
      label: "Wage and Salaried workers, female (% of female employment)",
      destination: "/data/inflation/wage-and-salaried-workers-female/",
      parent_id: 1000087,
      category_name: null
    },
    {
      id: 100001000,
      label: "Wage and Salaried workers, male (% of male employment)",
      destination: "/data/inflation/wage-and-salaried-workers-male/",
      parent_id: 1000087,
      category_name: null
    },
    {
      id: 10000210,
      label: "Foreign direct investment, net inflows (% of GDP)",
      destination:
        "/data/macroeconomy/foreign-direct-investment-net-inflows-of-gdp/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000213,
      label: "Foreign direct investment, net outflows (% of GDP)",
      destination:
        "/data/macroeconomy/foreign-direct-investment-net-outflows-of-gdp/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000216,
      label: "Foreign direct investment, net inflows (BoP, current US$)",
      destination:
        "/data/macroeconomy/foreign-direct-investment-net-inflows-bop-current-us/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000219,
      label: "Foreign direct investment, net outflows (BoP, current US$)",
      destination:
        "/data/macroeconomy/foreign-direct-investment-net-outflows-bop-current-us/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000222,
      label: "Portfolio Investment, net (BoP, current US$)",
      destination:
        "/data/macroeconomy/portfolio-investment-net-bop-current-us/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000225,
      label: "GDP",
      destination: "/data/inflation/gross-domestic-product-gdp/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000230,
      label: "GDP Growth",
      destination: "/data/inflation/gdp-growth/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000235,
      label: "GDP per Capita",
      destination: "/data/inflation/gdp-per-capita/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000240,
      label: "GDP per Capita Growth",
      destination: "/data/inflation/gdp-per-capita-growth/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000800,
      label: "GNI",
      destination: "/data/inflation/gross-national-income-at-current-prices/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000830,
      label: "GNI Growth",
      destination: "/data/inflation/gross-national-income-growth/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000810,
      label: "GNI per Capita",
      destination: "/data/inflation/gross-national-income-per-capita/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000820,
      label: "GNI per Capita Growth",
      destination: "/data/inflation/gross-national-income-per-capita-growth/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000840,
      label: "Purchasing Managers Index (PMI)",
      destination: "/dataset/macroeconomy/purchasing-managers-index-pmi/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 100001958,
      label: "Quarterly real GDP Growth",
      destination: "/datasets/quarterly-real-gdp-growth/",
      parent_id: 1000080,
      category_name: null
    },
    {
      id: 10000242,
      label: "Access to electricity (% of population)",
      destination: "/data/energy-monitor/access-to-electricity-of-population/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000243,
      label: "Access to electricity, urban (% of urban population)",
      destination:
        "/data/energy-monitor/access-to-electricity-urban-of-urban-population/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000244,
      label: "Access to electricity, rural (% of rural population)",
      destination:
        "/data/energy-monitor/access-to-electricity-rural-of-rural-population/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000248,
      label: "Electricity Production in Africa",
      destination: "/data/energy-monitor/electricity-production-in-africa/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000251,
      label: "Electricity Consumption per Capita",
      destination: "/data/energy-monitor/electricity-consumption-per-capita/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000255,
      label: "Average Petrol Price in Africa",
      destination: "/data/energy-monitor/average-petrol-price-in-africa/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000260,
      label: "Landing Cost of Petrol in Nigeria",
      destination: "/data/energy-monitor/landing-cost-of-petrol-in-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000270,
      label: "Petrol Prices in Nigeria",
      destination: "/data/energy-monitor/petrol-prices-in-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000280,
      label: "Diesel Prices in Nigeria",
      destination: "/data/energy-monitor/diesel-prices-in-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000290,
      label: "Kerosene Prices in Nigeria",
      destination: "/data/energy-monitor/kerosene-prices-in-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000295,
      label: "Cooking Gas Prices in Nigeria",
      destination: "/data/energy-monitor/cooking-gas-prices-in-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000300,
      label: "Fuel Consumption in Nigeria",
      destination: "/data/energy-monitor/fuel-consumption-in-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 10000309,
      label: "Carbon intensity of electricity generation",
      destination: "/data/energy/carbon-intensity-of-electricity-generation/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001150,
      label:
        "Proportion of population with primary reliance on  charcoal for cooking (%)",
      destination:
        "/data/energy/proportion-of-population-with-primary-reliance-on-charcoal-for-cooking/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001170,
      label:
        "Proportion of population with primary reliance on  electricity for cooking (%)",
      destination:
        "/data/energy/proportion-of-population-with-primary-reliance-on-electricity-for-cooking/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001190,
      label:
        "Proportion of population with primary reliance on  liquified petroluem gas (LPG) for cooking (%)",
      destination:
        "/data/energy/proportion-of-population-with-primary-reliance-on-lpg-for-cooking/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001210,
      label:
        "Proportion of population with primary reliance on  coal for cooking (%)",
      destination:
        "/data/energy/proportion-of-population-with-primary-reliance-on-coal-for-cooking/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001230,
      label:
        "Proportion of population with primary reliance on  biomass  for cooking (%)",
      destination:
        "/data/energy/proportion-of-population-with-primary-reliance-on-biomass-for-cooking/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001250,
      label:
        "Proportion of population with primary reliance on  kerosene for cooking (%)",
      destination:
        "/data/energy/proportion-of-population-with-primary-reliance-on-kerosene-for-cooking/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001260,
      label:
        "Average price of solar photovoltaic (PV) modules per Watt (USD/W)",
      destination:
        "/dataset/energy/average-price-of-solar-photovoltaic-pv-modules-per-watt-usd-w/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001270,
      label: "Solar photovoltaic (PV) module capacity (MW)",
      destination: "/dataset/energy/solar-photovoltaic-pv-module-capacity-mw/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001280,
      label: "Solar Photovoltaic (PV) Module Total Weight (kg)",
      destination:
        "/dataset/energy/solar-photovoltaic-pv-module-total-weight-kg/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001290,
      label: "Solar Photovoltaic (PV) Module Total Cost (USD)",
      destination:
        "/dataset/energy/solar-photovoltaic-pv-module-total-cost-usd/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001295,
      label: "Solar Photovoltaic (PV) Module Quantity (Number of Items)",
      destination:
        "/dataset/energy/solar-photovoltaic-pv-module-quantity-number-of-items/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001298,
      label: "Installed solar energy capacity (MW)",
      destination: "/dataset/energy/installed-solar-energy-capacity-mw/",
      parent_id: 1000030,
      category_name: null
    },

    {
      id: 10000300,
      label: "Consumer Readiness Index",
      destination: "/dataset/consumers/consumer-readiness-index/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000305,
      label: "SSA Financial Inclusion Index",
      destination: "/dataset/consumers/ssa-financial-inclusion-index/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000311,
      label:
        "Households and NPISHs Final consumption expenditure (US $ in billions)",
      destination:
        "/data/consumers/households-and-npishs-final-consumption-expenditure-us-in-billions/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000312,
      label:
        "Households and NPISHs Final consumption expenditure (annual % growth)",
      destination:
        "/data/consumers/households-and-npishs-final-consumption-expenditure-annual-growth/",
      parent_id: 1000033,
      category_name: null
    },

    {
      id: 10000313,
      label: "Population by Country",
      destination: "/data/consumers/population-by-country/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000316,
      label: "Population by Age group and Country",
      destination: "/data/consumers/population-by-age-group-and-country/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000700,
      label: "Internet Penetration",
      destination: "/data/consumers/internet-penetration/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000710,
      label: "Mobile phone subscription",
      destination: "/data/consumers/mobile-phone-subscriptions/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000720,
      label: "ATMs distribution",
      destination: "/data/consumers/atms-distribution/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000730,
      label: "Life expectancy at birth",
      destination: "/dataset/consumer/life-expectancy-at-birth/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000740,
      label: "Primary education, pupils",
      destination: "/dataset/consumer/primary-education-pupils/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000750,
      label: "Primary education, pupils (% female)",
      destination: "/dataset/consumer/primary-education-pupils-female/",
      parent_id: 1000033,
      category_name: null
    },
    {
      id: 10000319,
      label: "African Elections and Governance",
      destination: "#",
      parent_id: 1000036,
      category_name: null
    },

    {
      id: 10000320,
      label: "Exchange Rates",
      destination: "/data/exchange-rates/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000323,
      label: "Exchange Rate Forecast",
      destination: "/data/africa-fx-monitor/exchange-rate-forecast/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000330,
      label: "Angolan Kwanza (AOA)",
      destination:
        "/data/africa-fx-monitor/angolan-kwanza-aoa-africa-fx-monitor/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000340,
      label: "Egyptian Pound (EGP)",
      destination:
        "/data/africa-fx-monitor/egyptian-pounds-egp-africa-fx-monitor/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000350,
      label: "Ghanian Cedi (GHS)",
      destination:
        "/data/africa-fx-monitor/ghanian-cedi-ghs-africa-fx-monitor/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000360,
      label: "Kenyan Shilling (KES)",
      destination:
        "/data/africa-fx-monitor/kenyan-shillings-kes-africa-fx-monitor/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000370,
      label: "Nigerian Naira (NGN)",
      destination:
        "/data/africa-fx-monitor/nigerian-naira-ngn-africa-fx-monitor/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000380,
      label: "Rwandan Franc (RWF)",
      destination:
        "/data/africa-fx-monitor/rwandan-franc-rwf-africa-fx-monitor/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000390,
      label: "South African Rand (ZAR)",
      destination:
        "/data/africa-fx-monitor/south-african-rand-zar-africa-fx-monitor/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000400,
      label: "Ugandan Shilling (UGX)",
      destination:
        "/data/africa-fx-monitor/ugandan-shilling-ugx-africa-fx-monitor/",
      parent_id: 1000060,
      category_name: null
    },
    {
      id: 10000410,
      label: "West African CFA franc (XOF)",
      destination:
        "/data/africa-fx-monitor/west-african-cfa-franc-xof-africa-fx-monitor/",
      parent_id: 1000060,
      category_name: null
    },

    {
      id: 10000420,
      label: "Upcoming African Elections",
      destination: "/open-data/elections/upcoming-african-elections",
      parent_id: 10000319,
      category_name: null
    },
    {
      id: 10000440,
      label: "Senegal",
      destination: "/open-data/elections/senegal-elections",
      parent_id: 10000319,
      category_name: null
    },
    {
      id: 10000460,
      label: "Ghana",
      destination: "/open-data/elections/ghana-elections",
      parent_id: 10000319,
      category_name: null
    },
    {
      id: 10000480,
      label: "South Africa",
      destination: "/open-data/elections/south-africa-elections",
      parent_id: 10000319,
      category_name: null
    },
    {
      id: 10000500,
      label: "Botswana",
      destination: "/open-data/elections/botswana-elections",
      parent_id: 10000319,
      category_name: null
    },
    {
      id: 10000520,
      label: "Namibia",
      destination: "/open-data/elections/namibia-elections",
      parent_id: 10000319,
      category_name: null
    },
    {
      id: 10000540,
      label: "Chad",
      destination: "/open-data/elections/chad-elections/",
      parent_id: 10000319,
      category_name: null
    },
    {
      id: 10000600,
      label: "Exports as a percentage of GDP",
      destination: "/data/inflation/exports-as-a-percentage-of-gdp/",
      parent_id: 1000082,
      category_name: null
    },
    {
      id: 10000610,
      label: "Imports as a percentage of GDP",
      destination: "/data/inflation/imports-as-a-percentage-of-gdp/",
      parent_id: 1000082,
      category_name: null
    },
    {
      id: 10000620,
      label: "Trade as a percentage of GDP",
      destination: "/data/macroeconomy/trade-as-a-percentage-of-gdp/",
      parent_id: 1000082,
      category_name: null
    },
    {
      id: 100001270,
      label: "Annual Container Port Throughput (2010-2022)",
      destination: "/data/macroeconomy/annual-container-port-throughput/",
      parent_id: 1000082,
      category_name: null
    },
    {
      id: 100001300,
      label: "Weighted mean applied tariff rate, all products (%)",
      destination:
        "/data/macroeconomy/weighted-mean-applied-tariff-rate-all-products/",
      parent_id: 1000082,
      category_name: null
    },
    {
      id: 100001320,
      label: "Weighted mean most favoured nations tariff, all products (%)",
      destination:
        "/data/macroeconomy/weighted-mean-most-favored-nations-tariff-all-products/",
      parent_id: 1000082,
      category_name: null
    },
    {
      id: 100001340,
      label: "Tariff rate, most favoured nation, simple mean, all products (%)",
      destination:
        "/data/macroeconomy/tariff-rate-most-favored-nation-simple-mean-all-products/",
      parent_id: 1000082,
      category_name: null
    },
    {
      id: 100001360,
      label: "Tariff rate, applied, simple mean, all products (%)",
      destination:
        "/data/macroeconomy/tariff-rate-applied-simple-mean-all-products/",
      parent_id: 1000082,
      category_name: null
    },

    // Fiscal
    {
      id: 10000630,
      label: "Short-term debt (% of total external debt)",
      destination: "/data/macroeconomy/short-term-debt-of-total-external-debt/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001964,
      label: "External Debt-to-GDP",
      destination: "/datasets/external-debt-to-gdp/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001966,
      label: "Current Account Balance-to-GDP",
      destination: "/datasets/current-account-balance-to-gdp/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 10000640,
      label: "Short-term debt (% of total reserves)",
      destination: "/data/macroeconomy/short-term-debt-of-total-reserves/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 10000650,
      label: "Short-term external debt (current US$)",
      destination: "/data/macroeconomy/short-term-external-debt-current-us/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001380,
      label: "Govt expenditure to GDP ratio",
      destination: "/data/macroeconomy/govt-expenditure-to-gdp-ratio/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001400,
      label: "Debt to GDP ratio",
      destination: "/data/macroeconomy/debt-to-gdp-ratio/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001420,
      label: "Tax revenue to GDP ratio",
      destination: "/data/macroeconomy/tax-revenue-to-gdp-ratio/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001440,
      label: "Public debt (currency amount)",
      destination: "/data/macroeconomy/public-debt-currency-amount/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001460,
      label: "Budget deficit (-)/ surplus (+)",
      destination: "/data/macroeconomy/budget-deficit-and-surplus/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001820,
      label: "Debt service to GNI ratio (%)",
      destination: "/dataset/fiscal/debt-service-to-gni-ratio/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001840,
      label: "Gross savings (USD millions)",
      destination: "/dataset/fiscal/gross-savings-usd-millions/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001860,
      label: "Government revenue as a % of GDP",
      destination: "/dataset/fiscal/government-revenue-as-a-of-gdp/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001880,
      label: "Total Debt Stock",
      destination: "/dataset/macroeconomy/total-debt-stock/",
      parent_id: 1000084,
      category_name: null
    },
    {
      id: 100001921,
      label: "Interbank Rates, daily",
      destination: "/dataset/financial-services/interbank-rates-daily/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001922,
      label: "Sectoral Analysis of Deposit Money Banks Credit, Nigeria",
      destination:
        "/dataset/financial-services/sectoral-analysis-of-deposit-money-banks-credit-nigeria/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001923,
      label: "Deposit Money Banks Deposit Categories, Nigeria",
      destination:
        "/dataset/financial-services/deposit-money-banks-deposit-categories-nigeria/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001924,
      label: "Principal Financial Ratios of Deposit Money Banks, Nigeria",
      destination:
        "/dataset/financial-services/principal-financial-ratios-of-deposit-money-banks-nigeria/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001925,
      label: "Commercial Banks' Liabilities, Nigeria",
      destination:
        "/dataset/financial-services/commercial-banks-liabilities-nigeria/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001926,
      label: "Commercial Banks' Assets, Nigeria",
      destination:
        "/dataset/financial-services/commercial-banks-assets-nigeria/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001927,
      label: "Diaspora Remittances, Kenya",
      destination: "/dataset/financial-services/diaspora-remittances-kenya/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001928,
      label: "Mobile Payments Market Size, Kenya",
      destination:
        "/dataset/financial-services/mobile-payments-market-size-kenya/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001929,
      label: "Financial Infrastructures, Kenya",
      destination:
        "/dataset/financial-services/financial-infrastructures-kenya/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001930,
      label: "Volume and Value of Transactions, Kenya",
      destination:
        "/dataset/financial-services/volume-and-value-of-transactions-kenya/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001931,
      label: "Account Holders to Staff Ratio, Kenya",
      destination:
        "/dataset/financial-services/account-holders-to-staff-ratio-kenya/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001932,
      label: "Ownership and Asset Base of Commercial Banks, Kenya",
      destination:
        "/dataset/financial-services/ownership-and-asset-base-of-commercial-banks-kenya/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001933,
      label: "Sectoral change in Demand for Credit, Kenya",
      destination:
        "/dataset/financial-services/sectoral-change-in-demand-for-credit-kenya/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001959,
      label: "Direct Credits via Automated Clearing House, Ghana",
      destination:
        "/datasets/direct-credits-via-automated-clearing-house-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001960,
      label: "Direct Debits via Automated Clearing House, Ghana",
      destination: "/direct-debits-via-automated-clearing-house-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001961,
      label: "Payment Cheques cleared, Ghana",
      destination: "/datasets/payment-cheques-cleared-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001962,
      label: "E-Zwich Transactions, Ghana",
      destination: "/datasets/e-zwich-transactions-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001963,
      label: "Gh-Link Transactions, Ghana",
      destination: "/datasets/gh-link-transactions-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001964,
      label: "GHIPSS Instant Pay Transactions, Ghana",
      destination: "/datasets/ghipss-instant-pay-transactions-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001965,
      label: "Internet Banking Transactions , Ghana",
      destination: "/datasets/internet-banking-transactions-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001966,
      label: "Mobile Money Accounts Ownership, Ghana",
      destination: "/datasets/mobile-money-accounts-ownership-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001967,
      label: "Mobile Money Agents, Ghana",
      destination: "/datasets/mobile-money-agents-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001968,
      label: "Mobile Money Transactions, Ghana",
      destination: "/datasets/mobile-money-transactions-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001969,
      label: "Mobile Money, Balance on Float, Ghana",
      destination: "/datasets/mobile-money-balance-on-float-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001970,
      label: "Mobile Money Interoperability, Ghana",
      destination: "/datasets/mobile-money-interoperability-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001971,
      label: "Payment Cards Issued, Ghana",
      destination: "/datasets/payment-cards-issued-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001972,
      label: "Payment Terminals Deployed, Ghana",
      destination: "/datasets/payment-terminals-deployed-ghana/",
      parent_id: 1000010,
      category_name: null
    },
    {
      id: 100001934,
      label: "Fuel Prices, Kenya",
      destination: "/datasets/fuel-prices-kenya/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001935,
      label: "Fuel Prices, Ghana",
      destination: "/datasets/fuel-prices-ghana/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001936,
      label: "Fuel Prices, South Africa",
      destination: "/datasets/fuel-prices-south-africa/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001937,
      label: "Fuel Imports and Exports, Kenya",
      destination: "/datasets/fuel-imports-and-exports-kenya/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001938,
      label: "Fuel Imports and Exports, Ghana",
      destination: "/datasets/fuel-imports-and-exports-ghana/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001939,
      label: "Fuel Imports and Exports, South Africa",
      destination: "/datasets/fuel-imports-and-exports-south-africa/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001940,
      label: "Fuel Consumption, Kenya",
      destination: "/datasets/fuel-consumption-kenya/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001941,
      label: "Fuel Consumption, South Africa",
      destination: "/datasets/fuel-consumption-south-africa/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001942,
      label: "Fuel Consumption, Ghana",
      destination: "/datasets/fuel-consumption-ghana/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001943,
      label: "Fuel Prices, Nigeria",
      destination: "/datasets/fuel-prices-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001944,
      label: "Electricity Tariffs, South Africa",
      destination: "/datasets/electricity-tariffs-south-africa/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001945,
      label: "Electricity Tariffs, Kenya",
      destination: "/datasets/electricity-tariffs-kenya/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001946,
      label: "Electricity Tariffs, Ghana",
      destination: "/datasets/electricity-tariffs-ghana/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001947,
      label: "Electricity Tariffs, Egypt",
      destination: "/datasets/electricity-tariffs-egypt/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001948,
      label: "Electricity Tariffs, Nigeria",
      destination: "/datasets/electricity-tariffs-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001949,
      label: "Number of Electricity Customers by Category, Ghana",
      destination:
        "/datasets/number-of-electricity-customers-by-category-ghana/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001950,
      label: "Number of Electricity Customers by Category, Kenya",
      destination:
        "/datasets/number-of-electricity-customers-by-category-kenya/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001951,
      label: "Number of Electricity Customers by Category, South Africa",
      destination:
        "/datasets/number-of-electricity-customers-by-category-south-africa/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001952,
      label: "Installed Captive Solar Power",
      destination: "/datasets/installed-captive-solar-power/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001953,
      label: "Oil Prices, Brent Crude and Bonny Light",
      destination: "/datasets/oil-prices-brent-crude-and-bonny-light/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001954,
      label: "Number of Electricity Customers by DISCO, Nigeria",
      destination:
        "/datasets/number-of-electricity-customers-by-disco-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001956,
      label: "Oil Production by Terminal, Nigeria",
      destination: "/datasets/oil-production-by-terminal-nigeria/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001957,
      label: "Oil Production by Terminal, Ghana",
      destination: "/datasets/oil-production-by-terminal-ghana/",
      parent_id: 1000030,
      category_name: null
    },
    {
      id: 100001958,
      label: "Oil Production, Nigeria and Ghana",
      destination: "/datasets/oil-production-nigeria-and-ghana/",
      parent_id: 1000030,
      category_name: null
    }
  ]
}

// TOOL: Uncomment the code below to find the highest id(number)
// console.log(
//   "Highest SideBarMenuItemsMock ID: ",
//   Math.max(...NavigationMenuMock().map((item) => item.id))
// )

export default NavigationMenuMock
